/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable object-shorthand */
/* eslint-disable prefer-destructuring */
import { InitiativeBudgetData } from '@/features/canvas/types/budget-type';
import { components } from '@/types/api';

export const extractBudgetDataFromNodes = (
  nodes: components['schemas']['Node'][]
): InitiativeBudgetData[] => {
  const budgetArray: InitiativeBudgetData[] = [];

  nodes.forEach(node => {
    const initiative = node.initiative || (node as any).initiatives;
    if (!initiative?.budget) return;

    const budget = initiative.budget;
    const fields = budget.fields || [];

    // Extract values from fields
    const totalField = fields.find((f: any) => f.type === 'total');
    const capexField = fields.find((f: any) => f.type === 'capex');
    const opexField = fields.find((f: any) => f.type === 'opex');
    const spendField = fields.find((f: any) => f.type === 'spend');

    const totalBudget = parseFloat(String(totalField?.value || '0'));
    const capex = parseFloat(String(capexField?.value || '0'));
    const opex = parseFloat(String(opexField?.value || '0'));
    const spend = parseFloat(String(spendField?.value || '0'));

    // Debug the fields before and after extraction
    console.log('🔍 extractBudgetDataFromNodes - Raw fields:', fields);
    const customFieldsInExtraction = fields.filter((f: any) => ['big', 'small'].includes(f.type));
    console.log('🔍 extractBudgetDataFromNodes - Custom fields:', customFieldsInExtraction);

    customFieldsInExtraction.forEach((f: any) => {
      console.log('🔍 extractBudgetDataFromNodes - Custom field:', {
        id: f.id,
        type: f.type,
        title: f.title,
        // Check both snake_case and camelCase versions
        display_title: f.display_title,
        displayTitle: f.displayTitle,
        text_value: f.text_value,
        textValue: f.textValue,
        value: f.value,
        popup_show: f.popup_show,
        popupShow: f.popupShow,
        allKeys: Object.keys(f),
      });
    });

    const budgetData: InitiativeBudgetData = {
      initiative_id: initiative.id!,
      currency: budget.currency || 'GBP',
      total_budget: totalBudget,
      capex: capex,
      opex: opex,
      spend: spend,
      fields: fields, // This should preserve all field properties including text_value
      // Add the missing required properties
      calculated_total: totalBudget, // or capex + opex if that's how it's calculated
      created_at: budget.created_at || new Date().toISOString(),
      updated_at: budget.updated_at || new Date().toISOString(),
      total_budget_override: totalField?.total_override || false,
      formatted: {
        total_budget: totalBudget.toLocaleString('en-GB'),
        capex: capex.toLocaleString('en-GB'),
        opex: opex.toLocaleString('en-GB'),
        spend: spend.toLocaleString('en-GB'),
      },
    };

    // Debug the extracted budget data
    console.log('🔍 extractBudgetDataFromNodes - Extracted budgetData.fields:', budgetData.fields);

    budgetArray.push(budgetData);
  });

  return budgetArray;
};
